<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter" id="structure" role="doc-chapter">
<p class="sert"><span aria-label="ii" class="page" id="pii" role="doc-pagebreak"></span><img alt="" height="76" src="images/logo-urban-series.jpg" width="400"/></p>
<p class="sered">Edited by Lilia Fernández, Timothy J. Gilfoyle, Becky M. Nicolaides, and Amanda I. Seligman</p>
<p class="sered">James R. Grossman, Editor Emeritus</p>
<p class="serah"><span class="sm">RECENT</span> <span class="sm">TITLES</span> <span class="sm">IN</span> <span class="sm">THE</span> <span class="sm">SERIES</span></p>
<p class="seraft">Steven T. Moga, <i>Urban Lowlands: Environment and Poverty in Urban History</i></p>
<p class="ser">Andrew S. Baer, <i>Beyond the Usual Beating: The Jon Burge Police Torture Scandal and Social Movements for Police Accountability in Chicago</i></p>
<p class="ser">Ann Durkin Keating, <i>The World of Juliette Kinzie: Chicago before the Fire</i></p>
<p class="ser">Jeffrey S. Adler, <i>Murder in New Orleans: The Creation of Jim Crow Policing</i></p>
<p class="ser">David A. Gamson, <i>The Importance of Being Urban: Designing the Progressive School District, 1890–1940</i></p>
<p class="ser">Kara Schlichting, <i>New York Recentered: Building the Metropolis from the Shore</i></p>
<p class="ser">Mark Wild, <i>Renewal: Liberal Protestants and the American City after World War II</i></p>
<p class="ser">Meredith Oda, <i>The Gateway to the Pacific: Japanese Americans and the Remaking of San Francisco</i></p>
<p class="ser">Sean Dinces, <i>Bulls Markets: Chicago’s Basketball Business and the New Inequality</i></p>
<p class="ser">Julia Guarneri, <i>Newsprint Metropolis: City Papers and the Making of Modern Americans</i></p>
<p class="ser">Kyle B. Roberts, <i>Evangelical Gotham: Religion and the Making of New York City, 1783–1860</i></p>
<p class="ser">Timothy Neary, <i>Crossing Parish Boundaries: Race, Sports, and Catholic Youth in Chicago, 1914–1954</i></p>
<p class="ser">Julia Rabig, <i>The Fixers: Devolution, Development, and Civil Society in Newark, 1960–1990</i></p>
<p class="ser">Amanda I. Seligman, <i>Chicago’s Block Clubs: How Neighbors Shape the City</i></p>
<p class="ser">Aaron Shkuda, <i>The Lofts of SoHo: Gentrification, Art, and Industry in New York, 1950–1980</i></p>
<p class="ser">Mark Krasovic, <i>The Newark Frontier: Community Action in the Great Society</i></p>
<p class="ser">Ansley T. Erickson, <i>Making the Unequal Metropolis: School Desegregation and Its Limits</i></p>
<p class="ser">Andrew L. Slap and Frank Towers, eds., <i>Confederate Cities: The Urban South during the Civil War Era</i></p>
<p class="ser">Evan Friss, <i>The Cycling City: Bicycles and Urban America in the 1890s</i></p>
<p class="ser">Ocean Howell, <i>Making the Mission: Planning and Ethnicity in San Francisco</i></p>
<p class="ser">Benjamin Looker, <i>A Nation of Neighborhoods: Imagining Cities, Communities, and Democracy in Postwar America</i></p>
<p class="ser">Nancy H. Kwak, <i>A World of Homeowners: American Power and the Politics of Housing Aid</i></p>
<p class="ser">Andrew R. Highsmith, <i>Demolition Means Progress: Flint, Michigan, and the Fate of the American Metropolis</i></p>
<p class="ser">Lila Corwin Berman, <i>Metropolitan Jews: Politics, Race, and Religion in Postwar Detroit</i></p>
<p class="serpf">A complete list of series titles is available on the <a class="url" href="https://press.uchicago.edu/ucp/books/series/HSUA.html" target="_blank">University of Chicago Press website</a>.</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-sites-0003.vue?a62941d4